import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const ClockinsSecondaryViewStore = GenericFieldFactory("CLOCKINS_SECONDARY_VIEW", null);